// 工具耗時的串流旁路（#1406）。伺服器把秒數掛在 tool-result 的 toolMetadata 上，
// 但 ai@7.0.93 的 processUIMessageStream 在 tool-output-available／tool-output-error
// 兩個分支傳的是既有 part 的舊值而非 chunk.toolMetadata，值到不了瀏覽器。
//
// 所以另外送一筆 transient data part：transient 的不進 message.parts，
// 歷史重建那條路徑因此完全不受影響，前端只在 onData 收下、自己建表。
// 🔴 伺服器與前端共用這一支，型別字串只有一份，兩邊不會漂移。

/** data part 的型別字串。AI SDK 規定 data part 一律以 data- 起頭。 */
export const TOOL_ELAPSED_DATA_TYPE = 'data-tool-elapsed'

/** 一支工具的執行耗時。毫秒，整數，來自伺服器的同一份量測。 */
export interface ToolElapsedData {
  toolCallId: string
  elapsedMs: number
}

/** 組出要塞進 UI 串流的那一筆。transient 為 true：不留在 message.parts 裡。 */
export const toolElapsedChunk = (data: ToolElapsedData) => ({
  type: TOOL_ELAPSED_DATA_TYPE,
  data,
  transient: true,
})

/**
 * 從 onData 收到的東西裡認出這一筆。認不得就回 null——
 * 同一個 callback 會收到所有 data part，不篩就會把別人的資料當耗時。
 */
export const readToolElapsedData = (chunk: unknown): ToolElapsedData | null => {
  const part = chunk as { type?: unknown; data?: unknown } | null
  if (part?.type !== TOOL_ELAPSED_DATA_TYPE) return null
  const data = part.data as { toolCallId?: unknown; elapsedMs?: unknown } | null
  if (typeof data?.toolCallId !== 'string' || !data.toolCallId) return null
  if (!Number.isFinite(data.elapsedMs) || (data.elapsedMs as number) < 0) return null
  return { toolCallId: data.toolCallId, elapsedMs: data.elapsedMs as number }
}

export interface ToolElapsedStore {
  record: (data: ToolElapsedData) => void
  /** 伺服器報過的秒數；沒報過回 null，由呼叫端決定要不要退回前端計時器 */
  read: (toolCallId: string) => number | null
}

/** 這一頁收到的伺服器耗時。只認 toolCallId，整頁共用一份就夠（與 durations 同理）。 */
export const createToolElapsedStore = (): ToolElapsedStore => {
  const byToolCall = new Map<string, number>()
  return {
    record: ({ toolCallId, elapsedMs }) => {
      byToolCall.set(toolCallId, elapsedMs)
    },
    read: (toolCallId) => byToolCall.get(toolCallId) ?? null,
  }
}
